import { getLeFEOrigin } from '@utils/util';

export const LbgImageLeFE = () => (
    <iframe className="admin-iframe" title="镜像管理" src={`${getLeFEOrigin()}/#/app/admin/image`} />
);
